import { render, staticRenderFns } from "./DocumentLegislation.vue?vue&type=template&id=07113a7a"
import script from "./DocumentLegislation.vue?vue&type=script&lang=js"
export * from "./DocumentLegislation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports